export const defaultFileInfoState = {
    currentValueOwner: "",
    currentValuePath: "",
    currentValueRepo: "",
    currentValueParentCommit: "",
    currentValueBranch: ""}